import { useTranslation } from 'react-i18next';
import ForgotForm from '../forms/ForgotForm';
import { FormPage } from './FormPage';
import { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { config } from '../../shared/config';

const ForgotPage = () => {
  const { t } = useTranslation();
  const [sended, setSended] = useState<boolean>(false);
  const [searchParams] = useSearchParams();
  const backTo = searchParams.get('backTo');
  return sended ? (
    <div className="text-center  flex items-center justify-center">
      <div>
        <h2>{config.forgotSmsEnabled ? t('forgot password sms sended') : t('forgot password mail sended')}</h2>
        <div className="my-10">
          {backTo ? <Link to={backTo}>{t('back to previous')}</Link> : <Link to="/">{t('back to home')}</Link>}
        </div>
      </div>
    </div>
  ) : (
    <FormPage
      title={t('forgot password page title')}
      subtitle={t('forgot password page description')}
      component={<ForgotForm setSended={setSended} />}
    />
  );
};

export default ForgotPage;
